import * as _ from 'lodash';
import atypes from '../../actions/actionTypes';
import { errorTemplate, getError } from '../../reducers/utils';

const _template = {
    tenant: {},
    error: errorTemplate(),
    isLoading: false,
};

function newState() {
    return {
        ..._.cloneDeep(_template)
    }
}

export default function(state = newState(), action) {
    switch (action.type) {
        case atypes.ACCEPT_INVITATION_REQUEST: {
            return {
                ...state,
                isLoading: true,
            }
        }

        case atypes.ACCEPT_INVITATION_SUCCESS:{
            return {
                ...state,
                tenant: action.payload || /* istanbul ignore next */{},
                error: errorTemplate(),
                isLoading: false,
            }
        }

        case atypes.ACCEPT_INVITATION_FAILURE: {
            return {
                ...state,
                error: getError(action.payload,  'Unauthorized.'),
                isLoading: false,
            }
        }

        default:
            return state;
    }
}
